(function () {
  'use strict';

  /* --- Scroll reveal animations --- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Stagger hero child reveals --- */
  function initHeroStagger() {
    var hero = document.querySelector('.hero');
    if (!hero) return;

    var reveals = hero.querySelectorAll('[data-reveal]');
    reveals.forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.15) + 's';
    });

    requestAnimationFrame(function () {
      reveals.forEach(function (el) {
        el.classList.add('is-revealed');
      });
    });
  }

  /* --- Header scroll effect --- */
  var header = document.querySelector('[data-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* --- Mobile menu --- */
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileCloseBtns = document.querySelectorAll('[data-mobile-menu-close]');

  function openMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMobile() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobile);
  mobileCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', closeMobile);
  });

  /* Mobile submenu accordion */
  var submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
  submenuToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var submenu = toggle.nextElementSibling;
      if (submenu && submenu.classList.contains('mobile-menu__submenu')) {
        var isOpen = submenu.classList.contains('is-open');
        submenu.classList.toggle('is-open', !isOpen);
        var icon = toggle.querySelector('svg');
        if (icon) icon.style.transform = isOpen ? '' : 'rotate(180deg)';
      }
    });
  });

  /* --- Search overlay --- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var input = searchOverlay.querySelector('input[type="search"]');
    if (input) setTimeout(function () { input.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobile();
    }
  });

  /* --- Cart count badge sync --- */
  function updateCartBadges() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.setAttribute('data-count', cart.item_count);
        });
        if (window.DCR) window.DCR.cartCount = cart.item_count;
      })
      .catch(function () {});
  }

  if (window.DCR && window.DCR.cartCount === undefined) {
    updateCartBadges();
  }

  window.DCR = window.DCR || {};
  window.DCR.updateCartBadges = updateCartBadges;

  /* --- Init --- */
  function init() {
    initHeroStagger();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
